import { render, staticRenderFns } from "./WelfarePage.vue?vue&type=template&id=11f5c164&scoped=true&"
import script from "./WelfarePage.vue?vue&type=script&lang=js&"
export * from "./WelfarePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f5c164",
  null
  
)

export default component.exports